// Copyright 2025, University of Maryland, All Rights Reserved
import React from 'react'
import type { SchemaFieldType, SchemaField } from "@/types/schema-fields"
import { IntegerFieldEditor } from './IntegerField'
import { ObjectArrayFieldEditor } from './ObjectArrayField'
import { EnumFieldEditor } from './EnumField'
import { ScoreFieldEditor } from './ScoreField'
import { SimpleArrayFieldEditor } from './SimpleArrayField'
import { BaseField } from "@/components/config/workspace/schema/BaseField.tsx"

// Props interface for all field editors
interface FieldEditorProps {
  field: SchemaField
  onFieldUpdate: (field: SchemaField, updates: Partial<SchemaField>) => void
  onRemove: (field: SchemaField) => void
  onMoveUp?: (field: SchemaField) => void
  onMoveDown?: (field: SchemaField) => void
  isLoading?: boolean
  readonly_id?: boolean // Make field ID readonly
  non_deletable?: boolean // Make field non-deletable
  hide_title?: boolean // Hide the title field
  children?: React.ReactNode // Field-specific configuration
  // Position info for arrow buttons
  isFirst?: boolean
  isLast?: boolean
}

// Component type for field editors
export type FieldEditorComponent = React.ComponentType<FieldEditorProps>

/**
 * Get the appropriate field editor component for a field type
 */
export function getFieldEditorComponent(field_type: SchemaFieldType): FieldEditorComponent {
  switch (field_type) {
    case 'string':
      return BaseField
    case 'simple_array':
      return SimpleArrayFieldEditor
    case 'integer':
      return IntegerFieldEditor
    case 'object_array':
      return ObjectArrayFieldEditor
    case 'enum_field':
      return EnumFieldEditor
    case 'score':
      return ScoreFieldEditor
  }
}
